import type { AdapterFetchOptions, AdapterResult, MarketSourceAdapter } from '@/types/adapters';
import { SOURCE_REGISTRY } from '@/data/sourceRegistry';

/**
 * Redfin Data Center adapter -- SCAFFOLD ONLY, gated by ENABLE_REDFIN.
 *
 * Redfin's Data Center files are large national TSVs served from Redfin's
 * own static file host. Two things must be verified/resolved before this
 * can be flipped on in production:
 *   1. CORS: confirm the download host sends permissive CORS headers for
 *      browser fetch(), or add a same-origin proxy/scheduled download step.
 *   2. Terms of use: confirm redistribution/display terms for the fields
 *      you plan to show.
 * Until then this adapter deliberately returns no rows so the rest of the
 * app (join, scoring, map) runs unaffected -- Phase 1 must work with
 * ENABLE_REDFIN off, per the brief's acceptance criteria.
 */
export const redfinAdapter: MarketSourceAdapter = {
  meta: SOURCE_REGISTRY.redfin,

  async fetch(_options?: AdapterFetchOptions): Promise<AdapterResult> {
    if (!SOURCE_REGISTRY.redfin.enabled) {
      return { rows: [], warnings: [], isSampleData: false };
    }
    return {
      rows: [],
      warnings: [
        'redfin: ENABLE_REDFIN is on but the adapter is not yet implemented (CORS/ToS unverified). Returning no rows.',
      ],
      isSampleData: false,
    };
  },
};
